<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1>The Big Hit</h1>
<h2 style="margin-top:20px;">A Novel</h2>
<h3 style="margin-top:60px;">James Neal Harvey</h3>
<p class="center" style="margin-top:100px;"><img alt="Mysterious Press logo" src="image/MYsteriousPress-Black-CMYK.png"/></p>
<p class="center" style="margin-top:20px;"><img alt="Open Road logo" src="image/logo.jpg" width="30%"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Harvey_BigHit_5P_MD.vue?35cf3a74